/**
 * Quita en tiempo de ejecución las claves cuyo valor es `undefined`, y lo
 * refleja en el tipo.
 *
 * Con `exactOptionalPropertyTypes` activado, `{ emoji: undefined }` NO es
 * asignable a `{ emoji?: string }`: hay que OMITIR la clave. Los objetos que
 * salen de un `.parse()` de Zod traen los campos opcionales presentes con valor
 * `undefined`, así que hay que filtrarlos antes de mandarlos a Supabase.
 *
 * El tipo resultante marca como opcionales (ya sin `| undefined`) justo las
 * claves que podían serlo, y deja intactas las obligatorias.
 */
type StripUndefined<T> = {
  [K in keyof T as undefined extends T[K] ? K : never]?: Exclude<T[K], undefined>;
} & {
  [K in keyof T as undefined extends T[K] ? never : K]: T[K];
};

export function stripUndefined<T extends Record<string, unknown>>(obj: T): StripUndefined<T> {
  const out: Record<string, unknown> = {};
  for (const [k, v] of Object.entries(obj)) {
    if (v !== undefined) out[k] = v;
  }
  return out as StripUndefined<T>;
}
